import { Link } from "react-router-dom";
import { Hourglass } from "lucide-react";

export function DemoCountdown({ demo, compact = false, canUpgrade = true }) {
  if (!demo || demo.plan !== "demo" || demo.expired) return null;
  const n = demo.days_left;
  const warn = n <= 3;
  const text = `${n} ${n === 1 ? "day" : "days"} left in your free demo`;
  return (
    <div
      data-testid="demo-countdown"
      data-warning={warn ? "true" : "false"}
      className={`flex items-center gap-2 font-mono text-[11px] font-semibold uppercase tracking-wider ${
        compact ? "justify-center px-3 py-1.5" : "rounded-full px-3 py-1.5"
      } ${warn ? "bg-amber-500 text-slate-950" : compact ? "bg-slate-900 text-slate-300" : "bg-white/5 text-slate-300 ring-1 ring-white/10"}`}
    >
      <Hourglass className={`h-3.5 w-3.5 ${warn ? "" : "text-amber-400"}`} />
      <span data-testid="demo-countdown-text">{text}</span>
      {warn && canUpgrade && (
        <Link to="/upgrade" data-testid="demo-upgrade-link" className="rounded-full bg-slate-950 px-2 py-0.5 text-[10px] text-amber-400 hover:bg-slate-800">
          Upgrade
        </Link>
      )}
    </div>
  );
}
